import axios from 'axios';

import type { ZoomEmailMessage } from '../types/communication-data';

import { getHeaders } from './utils';

/**
 * What `/hooks/zoom-fetch-call-record/{id}` resolves to.
 *
 * A three-way union because the endpoint genuinely returns three shapes and the
 * `ContentRenderer` in all four consuming rows already dispatches on them at runtime —
 * `Array.isArray` for a transcript's lines, `typeof === 'object'` for an email thread,
 * `typeof === 'string'` for a recording URL. Those branches ARE the narrowing; the union
 * only states what they were already testing for.
 *
 * `null` is included because each row seeds its state with it and the specs pin a `null`
 * response (`unknownCallLogRow.interactions.spec.tsx` and its two siblings).
 */
export type ZoomCallRecord = string | string[] | { messages?: ZoomEmailMessage[] } | null;

export const connectGet = async <TData = ZoomCallRecord>(endpoint: string, token: string) => {
  const requestURL = `${import.meta.env.VITE_CONNECT_HOOKS_ENDPOINT}${endpoint}`;

  return await axios.get<TData>(requestURL, { headers: getHeaders(token) });
};

export const connectPost = async (token: string, endpoint: string, payload: unknown) => {
  const requestURL = `${import.meta.env.VITE_CONNECT_HOOKS_ENDPOINT}${endpoint}`;

  return await axios.post(requestURL, payload, { headers: getHeaders(token) });
};
